export const SCAN_TIME = [null, 7, 15, 30] as const
